import React from "react";
import { MuiHeader } from "../stories/header2";
import { GetUser } from "./../utils/sessions";
export default function Layout({ children }) {
  return (
    <>
      <MuiHeader user={GetUser()} >
        <>
          <section name="body" style={{ border:'5px solid #D8D8D8',top: "65px", position: "fixed",bottom: "0%",width: "100%",overflow: 'auto'  }}>{children}</section>
          <section name="footer"></section>
        </>
      </MuiHeader>
    </>
  );
}
